import { useQuery } from '@tanstack/react-query'
import { listDocuments } from '../api/plan-override-documents-api'
import { getApiErrorStatus } from '../utils/apiErrors'

export const DOCUMENTS_QUERY_KEY = 'overrideDocuments'

export function useOverrideDocuments(
  ruleId: string | undefined,
  ruleBase?: string
) {
  const { data, isLoading, error } = useQuery({
    queryKey: [DOCUMENTS_QUERY_KEY, ruleId, ruleBase],
    queryFn: () => listDocuments(ruleId ?? '', ruleBase),
    enabled: !!ruleId,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    retry: (failureCount, err) => {
      const status = getApiErrorStatus(err)
      if (status && status >= 400 && status < 500) return false
      return failureCount < 2
    },
  })

  return {
    documents: data ?? [],
    isLoading,
    error,
  }
}
